<script lang="ts" setup>
import { getInitials } from "@protein/core-vue3/helpers/utils"
import { VaAvatar } from "vuestic-ui"
const props = defineProps({
  name: {
    type: String as () => string | null,
    required: true,
  },
  imageBase64: {
    type: String as () => string | null,
    required: false,
  },
  imageUrl: {
    type: String as () => string | null,
    required: false,
  },
})
</script>

<template>
  <VaAvatar v-bind="props" v-if="props.imageBase64" :src="`data:image/png;base64,${props.imageBase64}`" />
  <VaAvatar v-bind="props" v-else-if="props.imageUrl" :src="props.imageUrl" />
  <VaAvatar v-bind="props" v-else>
    {{ getInitials(props.name ?? "") }}
  </VaAvatar>
</template>
